import { takeEvery } from 'redux-saga/effects';

import * as profileActions from 'store/modules/profile/actionTypes';
import { loadPushSubscription } from './utils';

export default function* listenLoadPushSubscription() {
  yield takeEvery(profileActions.LOAD_PUSH_SUBSCRIPTION, loadPushSubscription);
}
